import React from 'react';
import { connect } from 'react-redux';
import { getPictureUrlFromBase64 } from './../../../../../utils/index';
import { getSetsIdsByModel } from './../../../../../store/reducers/sets';
import { requestSetPictures, requestSetDescrPdf } from './../../../../../actions/sets';

const Model = ({
  models,
  model,
  id,
  sets,
  pictures,
  dispatch
}) => {
  const url = getPictureUrlFromBase64(pictures[model.picture]);
  const style = {
    display: 'flex',
    height: '100px',
    flex: '1',
    backgroundImage: 'url("' + url + '")',
    backgroundSize: 'contain',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat'
  }
  return (
    <div
      className='model-container'
      style={style}
      onClick={(e) => {
        e.stopPropagation();
        if (sets.length > 1) {
          dispatch({type: 'SET_MODEL', p: id});
          dispatch({type: 'SET_CATEGORY', p: models[id].categoryRef});
          dispatch({type: 'SET_SCREEN', name: 'modelSets', val: true});
        } else {
          if (sets.length === 1) {
            dispatch({type: 'SET_MODEL', p: id});
            dispatch({type: 'SET_CATEGORY', p: models[id].categoryRef});
            dispatch({ type: 'SET_SET', p: sets[0] });
            dispatch({ type: 'SET_SCREEN', name: 'setCard', val: true });
            dispatch(requestSetPictures());
            dispatch(requestSetDescrPdf());
          }
        }
      }}
    >
      <div
        style={{color: 'rgba(0,0,0,0.65)'}}
      >
        {model.descr}
      </div>
    </div>
  );
}

export default connect(
  (state, ownProps) => ({ pictures: state.pictures, models: state.models, sets: getSetsIdsByModel(state.sets, ownProps.id) })
)(Model);



// WEBPACK FOOTER //
// ./src/components/layout/content/catalog/models/item.js